export default class Team {
  constructor() {
    this.list = document.querySelector('.js-team-list');
    this.trigger = document.querySelector('.js-team-list-trigger');

    if (!this.list || !this.trigger) {
      return;
    }

    this.trigger.addEventListener('click', () => {
      this.list.classList.add('is--open');
      this.trigger.remove();
    });
  }
}
